module.exports = __webpack_public_path__ + "static/media/whiteDrive.2990382a.svg";